import { getAuth, signOut } from "firebase/auth";
import router from "@/router";

// 🔥 Verifica se a sessão ainda está ativa (baseado na última atividade)
export function isSessionActive() {
  const sessionData = JSON.parse(localStorage.getItem("userSession"));
  if (!sessionData) return false;

  const now = Date.now();
  return now - sessionData.timestamp < 12 * 60 * 60 * 1000; // 12h de inatividade
}

export async function logout() {
  const auth = getAuth();
  try {
    // dispara logout em outras abas
    localStorage.setItem("logout", Date.now().toString());

    await signOut(auth);
    localStorage.clear();
    sessionStorage.removeItem("ssoRedirectInFlight");

    console.log("📴 Logout realizado com sucesso.");
    router.push("/");
  } catch (error) {
    console.error("❌ Erro ao fazer logout:", error);
  }
}

export async function getFreshToken() {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    console.log("🔴 Nenhum usuário autenticado.");
    return null;
  }

  try {
    return await user.getIdToken(true); // 🔥 Força a renovação do token
  } catch (error) {
    console.error("❌ Erro ao obter token:", error);
    return null;
  }
}

export async function handleAuthError(router) {
  console.log("🔴 Token expirado ou sessão inativa. Forçando logout...");

  // 🔹 Limpa todas as informações da sessão antes de redirecionar
  localStorage.removeItem("userSession");
  localStorage.removeItem("userToken");
  localStorage.removeItem("qrActive");
  localStorage.removeItem("acessoComWhatsapp");
  localStorage.removeItem("currentPage");
  sessionStorage.removeItem("ssoRedirectInFlight");

  const auth = getAuth();

  // dispara logout em outras abas também
  localStorage.setItem("logout", Date.now().toString());

  await auth.signOut(); // 🔥 Garante que o Firebase encerre a sessão

  router.push("/");
}

export function storeSession(email) {
  localStorage.setItem(
    "userSession",
    JSON.stringify({ email, timestamp: Date.now() })
  );
}

// 🔥 Atualiza o timestamp da sessão sempre que o usuário interagir
export function updateSessionTimestamp() {
  const sessionData = JSON.parse(localStorage.getItem("userSession"));
  if (sessionData) {
    sessionData.timestamp = Date.now();
    localStorage.setItem("userSession", JSON.stringify(sessionData));
  }
}
